import { createContext, useState, useEffect, useCallback } from 'react';

export const StickySearchContext = createContext();

const useIntersectionObserver = callback => {
  const [observer, setObserver] = useState(null);

  const observe = selector => {
    const el = document.querySelector(selector);
    if (observer && el) {
      observer.observe(el);
    }
  };

  const disconnect = () => {
    if (observer) observer.disconnect();
  };

  useEffect(() => {
    setObserver(new IntersectionObserver(callback, {}));
  }, [callback]);

  return [observe, disconnect];
};

export default function StickySearchProvider({ children }) {
  const [isStickySearchBar, setStickySearchBar] = useState(false);
  const handleObserver = useCallback(entries => {
    const [entry] = entries;
    const { isIntersecting } = entry;
    setStickySearchBar(!isIntersecting);
  }, []);
  const [observe, disconnect] = useIntersectionObserver(handleObserver);

  const defaultContext = {
    isStickySearchBar,
    observe,
    disconnect
  };

  return (
    <StickySearchContext.Provider value={defaultContext}>
      {children}
    </StickySearchContext.Provider>
  );
}
